export default __webpack_public_path__ + "static/media/debitcard1.883bea09.png";